export default "__VITE_ASSET__CwG2o5tf__"